import React from "react";
import { withRouteData, Link } from "react-static";
import Markdown from "react-markdown";
import { Helmet } from "react-helmet";
import Img from "react-image";
import { MoonLoader } from "react-spinners";

//
class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }
  handleClick() {
    this.setState({
      condition: !this.state.condition
    });
    if (this.state.condition == true) {
      window.removeEventListener("scroll", this.handleScroll);
    } else {
      window.addEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll() {
    this.setState({
      condition: false
    });
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
        className={this.state.condition ? "spacing" : ""}
      >
        <Img
          {...this.props}
          className={this.state.condition ? "lightbox" : "not-lightbox"}
          onClick={this.handleClick}
          draggable="false"
          loader={<MoonLoader color="#fff" size={20} />}
        />
        <div
          className={
            this.state.condition ? "lightbox-background" : "not-lightbox"
          }
        />
      </div>
    );
  }
}

class Post extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: false,
      conditionTwo: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClickTwo = this.handleClickTwo.bind(this);
  }
  handleClick() {
    this.setState({
      condition: !this.state.condition
    });
  }
  handleClickTwo() {
    this.setState({
      conditionTwo: !this.state.conditionTwo
    });
  }
  render() {
    const { post } = this.props;

    return (
      <div className="blog-post">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            property="og:title"
            content={`soju.studio | ${post.data.title}`}
          />
          <meta property="og:description" content={post.data.description} />
          <meta property="og:image" content={post.data.thumbnail} />
          <meta property="og:url" content={post.data.slug} />
          <title>soju studio | {post.data.title}</title>
          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:title"
            content={`soju.studio | ${post.data.title}`}
          />
          <meta name="twitter:description" content={post.data.description} />
          <meta name="twitter:image" content={post.data.thumbnail} />
        </Helmet>
        <div
          className={
            this.state.condition
              ? "content-header content-header-mobile"
              : "content-header"
          }
        >
          <div className="description-header-background">
            <Link to="">← back</Link>
            <div className="description-header">
              <p className="title">{post.data.title}</p>
              <a
                className={
                  this.state.condition
                    ? "info-toggle info-toggled"
                    : "info-toggle"
                }
                onClick={this.handleClick}
              >
                ↓ info
              </a>
            </div>
          </div>
          <Markdown
            source={post.data.description}
            escapeHtml={false}
            className={
              this.state.condition
                ? "infos-displayed infos"
                : "infos infos-not-displayed"
            }
          />
          <div
            className={
              this.state.condition ? "infos-displayed" : "infos-not-displayed"
            }
          >
            <a
              className={
                this.state.conditionTwo
                  ? "credits-toggle credits-toggled"
                  : "credits-toggle"
              }
              onClick={this.handleClickTwo}
            >
              ↓ credits
            </a>
            <Markdown
              source={post.data.credits}
              escapeHtml={false}
              className={
                this.state.conditionTwo
                  ? "credits credits-displayed"
                  : "credits credits-not-displayed"
              }
            />
          </div>
        </div>

        <Markdown
          source={post.content}
          escapeHtml={false}
          className="images"
          renderers={{ image: Image }}
        />
      </div>
    );
  }
}
export default withRouteData(({ post }) => <Post post={post} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Post.js